import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
// import { RouterModule } from '@angular/router';
import { QueryList } from '../../providers/query-list';
import { element } from '@angular/core/src/render3/instructions';
// import { SearchAcctsComponent } from '../search-accts/search-accts.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.css']
})
export class ReceiptComponent implements OnInit {

  // acct_list = [{'acct_number':'', 'amount': ''}];
  public menu_item_id = '99';
  public add_auth;

  no = '';
  type = '';
  private dp = [];

  from_count = 1;
  private dp2 = [{
    'id': this.from_count, 'check': '0', 'acct_number': '', 'acct_name': '', 'amount': '', 
    'flag': 'new', 'key': '', 'rec_id': '0'
  }];

  to_count = 100000;
  private dp3 = [{
    'id': this.to_count, 'check': '0', 'acct_number': '', 'acct_name': '', 'amount': '', 
    'flag': 'new', 'key': '', 'rec_id': '0'
  }];

  accts = [];
  total = 0;
  total_amount = 0;
  displayedColumns = ['choose', 'invoice_no', 'total', 'invoice_date', 'paid_amount', 'remain_amount'];
  displayedColumns2 = ['check', 'acct_number', 'amount'];
  displayedColumns3 = ['check', 'acct_number', 'amount'];
  dataSource = new MatTableDataSource(this.dp);
  dataSource2 = new MatTableDataSource(this.dp2);
  dataSource3 = new MatTableDataSource(this.dp3);
  @ViewChild(MatSort) sort: MatSort;

  flag = false;
  allUnChecked = false;

  //update_inv_no = [];
  toDelete = [];
  search_obj = {
    'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longSearchField',
    'table_list': [
      {
        'table_name': '`sub_acct`', 'selected_no': 'acct_number',
        'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
        'condition': " AND `sub_acct`.`is_leaf` = '1' AND `sub_acct`.`is_cc` = '1'"
      }
    ]
  };

  model = {
    'receipt_type': 'cash_receipt', 'rec_no': '', 'date': new Date(), 'paid': '', 'payment_method': 'cash',
    'acct_number': '', 'cost_center': '0', 'bank_account_no': '', 'comment': '', 'total': '',
    'amount': '', 'bank_amount': '', 'check_no': '', 'flag': 'new', 'no': '0', 'year': '',
    'id': '0', 'bank_account': '', 'receipt_acct_id': '0', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id
  };

  cash_receipt_model = {
    'table_name': 'cash_receipt', 'cash_receipt_id': '0', 'cash_receipt_no': '', 'account_type': '', 'acct_name': '',
    'to_acct': '0', 'receipt_no': '', 'no': '0', 'year': '', 'receipt_date': '', 'acct_number': '', 'paid': '',
    'payment_method': '', 'check_no': '', 'flag': 'new', 'key': 'cash_receipt_id', 'cost_center': '0', 'bank_account_no': '',
    'comment': '', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'receipt_type': 'composite'
  };
  payment_voucher_model = {
    'table_name': 'payment_voucher', 'payment_voucher_id': '0', 'payment_voucher_no': '', 'account_type': '',
    'acct_name': '', 'from_acct': '0', 'voucher_no': '', 'no': '0', 'year': '', 'voucher_date': '',
    'acct_number': '', 'paid': '', 'check_no': '', 'flag': 'new', 'key': 'payment_voucher_id', 'payment_method': '',
    'cost_center': '0', 'bank_account_no': '', 'comment': '', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id,
    'voucher_type': 'composite'
  };

  from_acct = {
    sub_acct_name: "", sub_acct_name_en: "", sub_acct_id: '0', acct_number: '', mobile: '',
    account_type: ''
  };

  cost_centers = [];
  saveClicked = false;

  // acctDialogRef: MatDialogRef<SearchAcctsComponent>;
  // , public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public dialog_data: any, private dialogRef: MatDialogRef<ReceiptComponent>, 

  Success_Msg; Error_Msg; Acct_Placeholder; Acct_Msg; Casher_Acct_Msg;
  Bank_Acct_Msg; Rec_Type_Msg; Rec_Amount_Msg; Rec_Total_Msg;
  Rec_No_Msg; Payment_Method_Msg; Rec_No_Exist_Msg;
  No_From_Acct_Msg; No_To_Acct_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants, private queryList: QueryList,
    private router: Router, private route: ActivatedRoute, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Acct_Placeholder;
    // this.search_Bank['placeholder'] = this.Acct_Placeholder;
    // this.search_acct['placeholder'] = this.Acct_Placeholder;
    // this.search_casher['placeholder'] = this.Acct_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Rec_Type_Msg').subscribe((res: string) => {
      this.Rec_Type_Msg = res;
    });

    translate.get('Rec_Amount_Msg').subscribe((res: string) => {
      this.Rec_Amount_Msg = res;
    });

    translate.get('Rec_Total_Msg').subscribe((res: string) => {
      this.Rec_Total_Msg = res;
    });

    translate.get('Rec_No_Msg').subscribe((res: string) => {
      this.Rec_No_Msg = res;
    });

    translate.get('Acct_Msg').subscribe((res: string) => {
      this.Acct_Msg = res;
    });

    translate.get('Bank_Acct_Msg').subscribe((res: string) => {
      this.Bank_Acct_Msg = res;
    });

    translate.get('Casher_Acct_Msg').subscribe((res: string) => {
      this.Casher_Acct_Msg = res;
    });

    translate.get('Payment_Method_Msg').subscribe((res: string) => {
      this.Payment_Method_Msg = res;
    });

    translate.get('Rec_No_Exist_Msg').subscribe((res: string) => {
      this.Rec_No_Exist_Msg = res;
    });
    
    translate.get('No_From_Acct_Msg').subscribe((res: string) => {
      this.No_From_Acct_Msg = res;
    });

    translate.get('No_To_Acct_Msg').subscribe((res: string) => {
      this.No_To_Acct_Msg = res;
    });
  }

  ngOnInit() {
    let query = this.queryList.all_costCenter;
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cost_centers = data.data['list'];

        let costObj = { 'cc_id': '0', 'cc_number': '0', 'cc_name': 'الرئيسي', 'cc_name_en': 'Main' };
        this.cost_centers.unshift(costObj);
      });
  
    this.toDelete = [];
    this.getReceipt();
  }

  onChangeAcct = function (search_result: object) {
    this.accts.push(search_result);
    (document.getElementById('acct_number_' + search_result['row_id']) as HTMLInputElement).value = search_result['no'];

    let rec_id = document.getElementById('rec_id_' + search_result['row_id']) as HTMLInputElement;
    let flag = document.getElementById('flag_' + search_result['row_id']) as HTMLInputElement;
    
    //if the mode is edit and the record already there and need to be updated
    if (rec_id.value != '' && rec_id.value != '0') {
      if (flag.value == "none")
        (document.getElementById('flag_' + search_result['row_id']) as HTMLInputElement).value = 'update';
    }
  }

  getReceipt() {
    this.route.params.subscribe(params => {
      if (params['no'] != undefined && params['type'] != undefined) {
        this.no = params['no'];
        this.type = params['type'];

        let name, acct;
        if (this.type == 'cash_receipt') {
          name = 'receipt';
          acct = 'to_acct';
          this.cash_receipt_model['cash_receipt_no'] = this.no;
        }
        else if (this.type == 'payment_voucher') {
          name = 'voucher';
          acct = 'from_acct';
          this.payment_voucher_model['payment_voucher_no'] = this.no;
        }

        (document.getElementById('cash_receipt') as HTMLInputElement).disabled = true;
        (document.getElementById('payment_voucher') as HTMLInputElement).disabled = true;

        /////////////////////////////////  Get Receipt Detail /////////////////////////////////

        let receipt_detail = [];
        let query = "SELECT `" + this.type + "`.* FROM `" + this.type + "` WHERE " +
          "`" + this.type + "`.`" + this.type + "_no` = '" + this.no + "' AND `status` != '0'";
        let obj = { cmd: 'getList', query: query };
        
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            receipt_detail = data.data['list'][0];
            this.model['receipt_type'] = this.type;
            this.model['rec_no'] = receipt_detail[name + '_no'];
            this.model['date'] = new Date(receipt_detail[name + '_date']);

            this.model['paid'] = receipt_detail['paid'];
            this.model['cost_center'] = receipt_detail['cost_center'];
            this.model['payment_method'] = receipt_detail['payment_method'];
            this.model['comment'] = receipt_detail['comment'];
            this.model['flag'] = 'update';
            this.model['no'] = receipt_detail['no'];
            this.model['year'] = receipt_detail['year'];
            this.model['id'] = receipt_detail[this.type + '_id'];
            this.model['total'] = this.model['paid'];
            this.model['bank_account'] = receipt_detail[acct];
            this.model['acct_number'] = receipt_detail[acct];
            this.model['check_no'] = receipt_detail['check_no'];

            /////////////////////////////////  Get Composite Type And Acct List /////////////////////////////////

            query = "SELECT `" + this.type + "_acct`.*, `sub_acct`.`sub_acct_name`, `sub_acct`.`sub_acct_name_en` " +
              "FROM `" + this.type + "_acct`, `sub_acct` WHERE `" + this.type + "_acct`.`status` != '0' AND `" +
              this.type + "_acct`.`" + this.type + "_no` = '" + this.no + "' AND `" +
              this.type + "_acct`.`acct_number` = `sub_acct`.`acct_number`";
            obj = { cmd: 'getList', query: query };
            
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let acct_list = data.data['list'];
               
                if (acct_list.length > 0) {
                  this.dp2 = [];
                  this.dp3 = [];

                  acct_list.forEach(acct => {

                    if (acct.type == 'from') {
                      this.dp2.push({
                        'id': this.from_count, 'check': '0', 'acct_number': acct.acct_number,
                        'acct_name': acct.sub_acct_name + '-' + acct.sub_acct_name_en + '-' + acct.acct_number,
                        'rec_id': acct[name + '_acct_id'], 'amount': acct.amount, 'flag': 'none',
                        'key': name + '_acct_id'
                      });
                      this.from_count++;
                    }
                    else if (acct.type == 'to') {
                      this.dp3.push({
                        'id': this.to_count, 'check': '0', 'acct_number': acct.acct_number,
                        'acct_name': acct.sub_acct_name + '-' + acct.sub_acct_name_en + '-' + acct.acct_number,
                        'rec_id': acct[name + '_acct_id'], 'amount': acct.amount, 'flag': 'none',
                        'key': name + '_acct_id'
                      });
                      this.to_count++;
                    }

                    this.dataSource2 = new MatTableDataSource(this.dp2);
                    this.dataSource2.sort = this.sort;

                    this.dataSource3 = new MatTableDataSource(this.dp3);
                    this.dataSource3.sort = this.sort;
                  });

                }
              });
          });
      }

    });

    if (this.no == '')
      this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    else 
      this.add_auth = true;
  }

  change_amount(row) {
    if (this.model['flag'] == 'update') {
      if (row.flag != 'new')
        (document.getElementById('flag_' + row.id) as HTMLInputElement).value = 'update';
    }
  }

  addLine(type) {
    if (type == 'from') {
      this.from_count++;
      this.dp2.push({
        'id': this.from_count, 'check': '', 'acct_number': '', 'acct_name': '', 'amount': '', 'flag': 'new', 'key': '',
        'rec_id': '0'
      });
      this.dataSource2 = new MatTableDataSource(this.dp2);
      this.dataSource2.sort = this.sort;
    }
    else {
      this.to_count++;
      this.dp3.push({
        'id': this.to_count, 'check': '', 'acct_number': '', 'acct_name': '', 'amount': '', 'flag': 'new', 'key': '',
        'rec_id': '0'
      });
      this.dataSource3 = new MatTableDataSource(this.dp3);
      this.dataSource3.sort = this.sort;
    }
  }

  delLine(type) {
    let count = 0;

    if (type == 'from') {
      for (let index = (this.dp2.length - 1); index >= 0; index--) {
        let id = this.dp2[index]['id'];
        let check = document.getElementById('check_' + id) as HTMLInputElement;
        let flag = document.getElementById('flag_' + id) as HTMLInputElement;
        if (check.checked == true) {
          if (flag.value != '' && flag.value != undefined && flag.value != 'new') {
            this.toDelete.push(this.dp2[index]);
          }
          this.dp2.splice(index, 1);
          this.dataSource2 = new MatTableDataSource(this.dp2);
          this.dataSource2.sort = this.sort;
          count++;
        }
      }
    }
    else {
      for (let index = (this.dp3.length - 1); index >= 0; index--) {
        let id = this.dp3[index]['id'];
        let check = document.getElementById('check_' + id) as HTMLInputElement;
        let flag = document.getElementById('flag_' + id) as HTMLInputElement;
        if (check.checked == true) {
          if (flag.value != '' && flag.value != undefined && flag.value != 'new') {
            this.toDelete.push(this.dp3[index]);
          }
          this.dp3.splice(index, 1);
          this.dataSource3 = new MatTableDataSource(this.dp3);
          this.dataSource3.sort = this.sort;
          count++;
        }
      }
    }
  }

  add() {
    this.saveClicked = true;

    if (this.model['receipt_type'] == '') {
      alert(this.Rec_Type_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['paid'] == '' || Number(this.model['paid']) == 0) {
      alert(this.Rec_Amount_Msg);
      this.saveClicked = false;
      return;
    }

    // if (this.model['payment_method'] == '') {
    //   alert(this.Payment_Method_Msg);
    //   this.saveClicked = false;
    //   return;
    // }

    let amount;
    let total_from_amount = 0;
    let total_to_amount = 0;

    let acct_number;
    let has_from_acct = true;
    let has_to_acct = true;

    this.dp2.forEach(element => {
      amount = document.getElementById('amount_' + element.id) as HTMLInputElement;
      if (Number(amount.value) > 0) {
        total_from_amount += Number(amount.value);
        
        acct_number = (document.getElementById('acct_number_' + element.id) as HTMLInputElement).value;
        if (acct_number == '')
          has_from_acct = false;
      }
    });

    this.dp3.forEach(element => {
      amount = document.getElementById('amount_' + element.id) as HTMLInputElement;
      if (Number(amount.value) > 0) {
        total_to_amount += Number(amount.value);

        acct_number = (document.getElementById('acct_number_' + element.id) as HTMLInputElement).value;
        if (acct_number == '')
          has_to_acct = false;
      }
    });
    
    if (Number(this.model['paid']) != Number(total_from_amount.toFixed(2)) || 
      Number(this.model['paid']) != Number(total_to_amount.toFixed(2))) {
      alert(this.Rec_Total_Msg);
      this.saveClicked = false;
      return;
    }

    if (!has_from_acct) {
      alert(this.No_From_Acct_Msg);
      this.saveClicked = false;
      return;
    }

    if (!has_to_acct) {
      alert(this.No_To_Acct_Msg);
      this.saveClicked = false;
      return;
    }

    let query, obj;

    if (this.model['rec_no'] == "")
      this.saveReceipt()
    else {
      if (this.model['receipt_type'] == 'cash_receipt') {
        query = "SELECT * FROM `cash_receipt` WHERE `receipt_no` = '" + this.model['rec_no'] + "'";
        // "' AND `acct_number` = '" + this.from_acct.acct_number + "'";   this.model['composite_type'] != "composite" && 

        if (this.model['id'] != '0')
          query += " AND `cash_receipt_id` != '" + this.model['id'] + "'";
      }
      else {
        query = "SELECT * FROM `payment_voucher` WHERE `voucher_no` = '" + this.model['rec_no'] + "'";
        // "' AND `acct_number` = '" + this.from_acct.acct_number + "'";

        if (this.model['id'] != '0')
          query += " AND `payment_voucher_id` != '" + this.model['id'] + "'";
      }
      console.log(query);
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let result = data.data['list'];
          if (result.length > 0) {
            alert(this.Rec_No_Exist_Msg);
            (document.getElementById('rec_no') as HTMLInputElement).focus();
            this.saveClicked = false;
            return;
          }
          else
            this.saveReceipt();
        });
    }
  }

  saveReceipt() {
    let obj;
    let values = [];
    let year, idWhere, prefix;

    if (this.model['receipt_type'] == 'cash_receipt') {

      this.cash_receipt_model['receipt_date'] = (this.model['date'].getFullYear() + "-" +
        (this.model['date'].getMonth() + 1) + "-" + this.model['date'].getDate()
        + ' ' + (new Date()).getHours() + ':' + (new Date()).getMinutes() +
        ':' + (new Date()).getSeconds());

      if (this.model['flag'] != 'update') {
        year = this.model['date'].getFullYear();
        this.cash_receipt_model['year'] = year.toString();
      }
      else 
        this.cash_receipt_model['year'] = this.model['year'];
      this.cash_receipt_model['no'] = this.model['no'];

      this.cash_receipt_model['receipt_no'] = this.model['rec_no'];
      this.cash_receipt_model['acct_number'] = this.from_acct.acct_number;
      this.cash_receipt_model['account_type'] = this.from_acct.account_type;
      this.cash_receipt_model['acct_name'] = this.from_acct.sub_acct_name;
      this.cash_receipt_model['to_acct'] = ''; // (this.model['composite_type'] == "composite" ? '' : (this.model['payment_method'] == 'cash' ? this.model['acct_number'] : this.model['bank_account_no']));
      this.cash_receipt_model['paid'] = this.model['paid'];
      this.cash_receipt_model['payment_method'] = this.model['payment_method'];
      this.cash_receipt_model['check_no'] = this.model['check_no'];
      this.cash_receipt_model['cost_center'] = this.model['cost_center'];
      this.cash_receipt_model['bank_account_no'] = ''; // (this.model['composite_type'] == "composite" ? '' : this.model['bank_account_no']);
      this.cash_receipt_model['comment'] = this.model['comment'];
      this.cash_receipt_model['flag'] = this.model['flag'];
      this.cash_receipt_model['cash_receipt_id'] = this.model['id'];

      values.push(this.cash_receipt_model);

      //// add acct list to values 

      this.dp2.forEach(element => {
        let amount = document.getElementById('amount_' + element.id) as HTMLInputElement;
        let flag = document.getElementById('flag_' + element.id) as HTMLInputElement;
        let acct_number = document.getElementById('acct_number_' + element.id) as HTMLInputElement;

        if (Number(amount.value) > 0 || (Number(amount.value) == 0 && element.rec_id != '0')) {
          if (Number(amount.value) == 0 && element.rec_id != '0')
            flag.value = 'delete';

          values.push({
            'table_name': 'cash_receipt_acct', 'cash_receipt_no': this.cash_receipt_model['cash_receipt_no'],
            'receipt_acct_id': element.rec_id, 'flag': flag.value, 'key': 'receipt_acct_id',
            'acct_number': acct_number.value, 'amount': amount.value, 'type': 'from'
          });
        }
      });

      this.dp3.forEach(element => {
        let amount = document.getElementById('amount_' + element.id) as HTMLInputElement;
        let flag = document.getElementById('flag_' + element.id) as HTMLInputElement;
        let acct_number = document.getElementById('acct_number_' + element.id) as HTMLInputElement;

        if (Number(amount.value) > 0 || (Number(amount.value) == 0 && element.rec_id != '0')) {
          if (Number(amount.value) == 0 && element.rec_id != '0')
            flag.value = 'delete';

          values.push({
            'table_name': 'cash_receipt_acct', 'cash_receipt_no': this.cash_receipt_model['cash_receipt_no'],
            'receipt_acct_id': element.rec_id, 'flag': flag.value, 'key': 'receipt_acct_id',
            'acct_number': acct_number.value, 'amount': amount.value, 'type': 'to'
          });
        }
      });

      this.toDelete.forEach(delElem => {
        values.push({
          'table_name': 'cash_receipt_acct',
          'receipt_acct_id': delElem.rec_id, 'flag': 'delete', 'key': 'receipt_acct_id',
          'cash_receipt_no': this.cash_receipt_model['cash_receipt_no'], 'acct_number': delElem.acct_number, 'amount': '0'
        });
      });


      if (this.model['flag'] == 'update')
        obj = { cmd: 'updateAdv', values: values };
      else {
        idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + this.model['branch_id'] + "'";
        prefix = this.model['branch_id'] + '-' + year + '-';
        obj = {
          cmd: 'add', values: values, pk: 'cash_receipt_no', id: 'no', main_table: 'cash_receipt',
          prefix: prefix, idWhere: idWhere
        };
      }
    }
    else if (this.model['receipt_type'] == 'payment_voucher') {

      this.payment_voucher_model['voucher_date'] = (this.model['date'].getFullYear() + "-" +
        (this.model['date'].getMonth() + 1) + "-" + this.model['date'].getDate()
        + ' ' + (new Date()).getHours() + ':' + (new Date()).getMinutes() +
        ':' + (new Date()).getSeconds());

      if (this.model['flag'] != 'update') {
        year = this.model['date'].getFullYear();
        this.payment_voucher_model['year'] = year.toString();
      }
      else 
        this.payment_voucher_model['year'] = this.model['year'];
      this.payment_voucher_model['no'] = this.model['no'];

      this.payment_voucher_model['voucher_no'] = this.model['rec_no'];
      this.payment_voucher_model['acct_number'] = this.from_acct.acct_number;
      this.payment_voucher_model['account_type'] = this.from_acct.account_type;
      this.payment_voucher_model['acct_name'] = this.from_acct.sub_acct_name;
      this.payment_voucher_model['from_acct'] = ''; // (this.model['composite_type'] == "composite" ? '' : (this.model['payment_method'] == 'cash' ? this.model['acct_number'] : this.model['bank_account_no']));
      this.payment_voucher_model['paid'] = this.model['paid'];
      this.payment_voucher_model['payment_method'] = this.model['payment_method'];
      this.payment_voucher_model['check_no'] = this.model['check_no'];
      this.payment_voucher_model['cost_center'] = this.model['cost_center'];
      this.payment_voucher_model['bank_account_no'] = ''; // (this.model['composite_type'] == "composite" ? '' : this.model['bank_account_no']);
      this.payment_voucher_model['comment'] = this.model['comment'];
      this.payment_voucher_model['flag'] = this.model['flag'];
      this.payment_voucher_model['payment_voucher_id'] = this.model['id'];

      values.push(this.payment_voucher_model);

      this.dp2.forEach(element => {
        let amount = document.getElementById('amount_' + element.id) as HTMLInputElement;
        let flag = document.getElementById('flag_' + element.id) as HTMLInputElement;
        let acct_number = document.getElementById('acct_number_' + element.id) as HTMLInputElement;
        values.push({
          'table_name': 'payment_voucher_acct', 'payment_voucher_no': this.payment_voucher_model['payment_voucher_no'],
          'voucher_acct_id': element.rec_id, 'flag': flag.value, 'key': 'voucher_acct_id',
          'acct_number': acct_number.value, 'amount': amount.value, 'type': 'from'
        });
      });

      this.dp3.forEach(element => {
        let amount = document.getElementById('amount_' + element.id) as HTMLInputElement;
        let flag = document.getElementById('flag_' + element.id) as HTMLInputElement;
        let acct_number = document.getElementById('acct_number_' + element.id) as HTMLInputElement;
        values.push({
          'table_name': 'payment_voucher_acct', 'payment_voucher_no': this.payment_voucher_model['payment_voucher_no'],
          'voucher_acct_id': element.rec_id, 'flag': flag.value, 'key': 'voucher_acct_id',
          'acct_number': acct_number.value, 'amount': amount.value, 'type': 'to'
        });
      });

      this.toDelete.forEach(delElem => {
        values.push({
          'table_name': 'payment_voucher_acct',
          'voucher_acct_id': delElem.rec_id, 'flag': 'delete', 'key': 'voucher_acct_id',
          'payment_voucher_no': this.payment_voucher_model['payment_voucher_no'], 'acct_number': delElem.acct_number, 'amount': '0'
        });
      });

      if (this.model['flag'] == 'update')
        obj = { cmd: 'updateAdv', values: values };
      else {
        idWhere = " WHERE `year` = '" + year  + "' AND `branch_id` = '" + this.model['branch_id'] + "'";
        prefix = this.model['branch_id'] + '-' + year + '-';
        obj = {
          cmd: 'add', values: values, pk: 'payment_voucher_no', id: 'no', main_table: 'payment_voucher',
          prefix: prefix, idWhere: idWhere
        };
      }
    }
    console.log(obj);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
          let receipt_no;
          if (this.model['flag'] != 'update')
            receipt_no = data.status['msg']['0']['number'];
          else
            receipt_no = this.no;

          alert(this.Success_Msg + this.Rec_No_Msg + ' ' + receipt_no);
          this.router.navigate(['sub_menu/3/receipt_list']);
      
          window.open(this.applicationConstants.generatePDF + "?receipt_type=" + this.model['receipt_type'] + 
            "&receipt_no=" + receipt_no + "&lang=" + this.applicationConstants.user_lang, "_blank");
        }
        else {
          alert(this.Error_Msg);
          this.saveClicked = false;
        }
      });
  }

}
